import Vue from 'vue';

export function setupGtmPageTracking(router, to) {
  setTimeout(() => {
    const isMobileApp = router.app.$store?.state?.general?.isMobileApp;
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    const gtmData = to.gtm || {
      event: 'vueRoute',
      pageTitle: document?.title || '',
      pageType: 'PageView',
      pageUrl: to.fullPath,
      page_region: Vue.prototype.$domainRegion,
      page_language: router.app.$i18n.locale,
      routeName: to.name,
      loginId: router.app.$store.state.auth?.user?.profileId,
      client_device_type: isMobileApp
        ? 'mobile_app'
        : /android|ipad|iphone|ipod|ios/i.test(userAgent)
        ? 'web_responsive'
        : 'desktop'
    };

    Vue.prototype.$gtm.push(gtmData);
  }, 1000);
}
